function sanitizeUrl(url: string) {
    const allowedProtocols = ["http:", "https:"];

    try {
        const parsedUrl = new URL(url);
        if (allowedProtocols.includes(parsedUrl.protocol)) {
            return url;
        }
    } catch {
        console.warn("Invalid URL", url);
    }

    return "about:blank";
}

export default sanitizeUrl;
